import React, {useState, useEffect} from "react";
import {Form, Container, Card} from "react-bootstrap";
import "./Vendormaster.css";
import axios from "../../util/Axios/AxiosInstance";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as ReactBootStrap from "react-bootstrap";
import filterFactory, {textFilter} from "react-bootstrap-table2-filter";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import edit from "../../../images/edit.png";
import TableActionIcon from "../../util/TableActionIcon";
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function VendorMasterDataTable({HandleEvent, HandleEventGetId}) {
    const [tableData, setTableData] = useState([
        {branch: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>, contractorAge: <Skeleton/>},
        {branch: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>, contractorAge: <Skeleton/>},
        {branch: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>, contractorAge: <Skeleton/>},
        {branch: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>, contractorAge: <Skeleton/>},
        {branch: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>, contractorAge: <Skeleton/>},
        {branch: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>, contractorAge: <Skeleton/>}
    ]);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const options = {
        onSizePerPageChange: (sizePerPage, page) => {
            setPageSize(sizePerPage);
            // setPageNumber(page);
        }, onPageChange: (page, sizePerPage) => {
            // setPageSize(sizePerPage);
            setPageNumber(page);
        },
    };
    const getVendorMasterDataByBranchId = async (branchId) => {
        try {
            const data = await axios.get("getVendorMasterDetailsByBranchId/" + branchId);
            setTableData(data.data);
            setLoading(true);
        } catch (e) {
        }
    };

    useEffect(() => {
        AOS.init();
        const branchId = localStorage.getItem("branchId");
        getVendorMasterDataByBranchId(branchId);
    }, []);

    //  const selectRow = {
    //   // mode: 'button',
    //   clickToSelect: true,
    //   selectColumnPosition: 'right',
    //   onSelect: (row, isSelect, rowIndex, e) => {
    //
    //
    //
    //
    //     HandleEventGetId(10,row)
    //   }
    // };

    // const editData = (row) =>{
    // HandleEventGetId(10,row)
    // };

    const updateStatus = (row) => {
        if (row.status) {
            row.status = 0;
        } else {
            row.status = 1;
        }
        axios.put("updateVendorMasterDetails",row)
            .then((data) => {

            })
            .catch((err) => {
                console.log(err)
            })
        // const url = "updateVendorMasterDetails";

        // fetch(url, {
        //     method: "PUT", headers: {
        //         Accept: "application/json", "Content-Type": "application/json",
        //     }, body: JSON.stringify(row),
        // }).then((result) => {
        //     result.json().then((resp) => {
        //         // if(row.status){
        //         //   alert("Status Set to Active, ID: " + row.id);
        //         // }
        //         // else{
        //         //   alert("Status set to Inactive, ID: " + row.id);
        //         // }
        //         // console.warn(resp)
        //     });
        // });
    };


    const users = [{id: "1", name: "something", email: "something@example.com", password: "kjg"}, {
        id: "1", name: "something", email: "something@example.com", password: "kjg"
    }, {id: "1", name: "something", email: "something@example.com", password: "kjg"}, {
        id: "1", name: "something", email: "something@example.com", password: "kjg"
    }, {id: "1", name: "something", email: "something@example.com", password: "kjg"}, {
        id: "1", name: "something", email: "something@example.com", password: "kjg"
    }, {id: "1", name: "something", email: "something@example.com", password: "kjg"},]

    function dosomething() {
        // console.log('nothing');
    }

    const columns = [{
        dataField: "id", text: "S No.", formatter: (cell, row, rowIndex) => {
            //
            //
            //
            return (pageNumber - 1) * pageSize + (rowIndex + 1);
        }, headerStyle: (colum, colIndex) => {
            return {width: "60px", textAlign: "center"};
        }, title: (cell, row, rowIndex, colIndex) => `${cell}`,
    }, 
    {dataField: "branch", text: "Branch", title: (cell, row, rowIndex, colIndex) => `${cell}`}, 
    
    {
        dataField: "contractName", text: "Contract Name", sort: true, filter: textFilter(),
        title: (cell, row, rowIndex, colIndex) => `${cell}`,
    }, {
        dataField: "vendorName", text: "Vendor Name", sort: true, filter: textFilter(),
        title: (cell, row, rowIndex, colIndex) => `${cell}`,
    }, {
        dataField: "status", text: "Status", formatter: (cellContent, row) => {
            return (<Form.Check
                type="switch"
                id="custom-switch"
                defaultChecked={cellContent}
                onClick={() => {
                    (loading === true) ? updateStatus(row) : dosomething();
                }}
            ></Form.Check>);
        },
    }, {
            dataField: "labourDob",
            text: "Edit",
            isDummyField: true,
            csvExport: false,
            formatter: (cellContent, row) => {
                return (
                    <TableActionIcon
                        src={edit}
                        title="Edit vendor"
                        disabled={!loading}
                        onClick={() => HandleEventGetId(12, row)}
                    />
                );
            },
    },];

    return (<Card className="cardStyl">
        <Container fluid className="px-0">
            <div className={"mt-2"}>
                <h5 className={"priColor"}>Vendor List</h5>
            </div>
            <div>
                <div className={"row"}>
                    <div style={{marginBottom: "10px"}}>
                        <button
                            className={"btn btn-primary"}
                            variant="primary"
                            style={{float: "right"}}
                            onClick={(e) => HandleEvent(11)}
                        >
                            Add Vendor
                        </button>
                    </div>
                </div>
                <div data-aos="zoom-in-right" data-aos-duration="550">
                    <BootstrapTable
                        bootstrap4
                        keyField="id"
                        data={tableData}
                        columns={columns}
                        wrapperClasses="table-responsive"
                        pagination={paginationFactory()}
                        filter={filterFactory(options)}
                    />
                </div>
            </div>
        </Container>
    </Card>);
}

export default VendorMasterDataTable;

